import type { Dispatch, SetStateAction } from "react";
import { createContext, useContext } from "react";

import type { ArticlesSearchOrderByInput } from "~/queries/__generated__/searchArticleResultPaginationQuery.graphql";

type ContextValue = {
  currentValue: string;
  orderBy?: ArticlesSearchOrderByInput;
  setOrderBy?: Dispatch<SetStateAction<ArticlesSearchOrderByInput | undefined>>;
};

export const SearchContext = createContext<ContextValue>({
  currentValue: "",
});

export const useSearchContext = () => useContext(SearchContext);
